module.exports = __webpack_public_path__ + "img/578-42dfb3.png";